import { Component } from '@angular/core';

@Component({
  selector: 'footer',
  template: `
  <div class="footer-copyright" style="background-color: #007bff;">
    <div class="container-fluid">
      © 2017 Copyright:
      <a href="http://www.odusseuserp.org">Odusseus</a>
    </div>
  </div>`,
})

export class FooterComponent {
}
